// extracted by mini-css-extract-plugin
export default {"diceContainer":"Dice_diceContainer__Nydff","dice":"Dice_dice__Me6vB","rollButton":"Dice_rollButton__HXHjz"};